<template>
  <div
    v-if="items.length"
    :class="['root', { 'root--active': isVisible}]"
  >
    <Scroller
      @change="handleActiveChange"
      :root-margin="rootMargin"
    >
      <div slot="foreground">
        <div
          v-for="(item, idx) in formattedItems"
          :key='idx'
          :class="['section', { 'section--active': idx === activeSection, 'section--passed': idx < activeSection}, item.modifiers || '']"
        >
          <div
            v-if="item.type === 'paragraph'"
            class="paragraph"
          >
            <!--<span v-for="(paragraph, idx) in item.value" :key="idx" :content="paragraph" v-html="item.value" />-->
            <Paragraph
              v-for="(paragraph, idx) in item.value"
              :key="idx"
              :content="{item: paragraph}"
            />
          </div>
          <ScrollVoiceText
            v-else-if="item.type === 'sound'"
            :imageId="item.value['image-id']"
            :soundId="item.value['sound-id']"
            :isIntro="true"
            :callToAction="item.value['call-to-action']"
          />
          <Memorial v-else-if="item.type === 'memorial'" />
          <Logo
            v-else-if="item.type === 'logo'"
            :type="'small'"
          />
          <div
            v-else-if="item.type === 'img-lead'"
            class="dh-psy-img-lead"
          >
            <div>
              <Logo
                v-if="item.value.logo"
                :type="'large'"
              />
            </div>
            <div
              v-if="item.value.img"
              class="dh-psy-img-lead__illustration"
            >
              <Illustration :id="item.value.img" />
            </div>
            <p
              class="dh-psy-lead"
              v-html="item.value.text"
            />
          </div>
          <p
            v-else
            class="dh-psy-lead"
            v-html="item.value"
          />
        </div>
        <div
          v-if="isIntro"
          :class="['section', { 'section--active': activeSection === formattedItems.length, 'section--passed':  formattedItems.length < activeSection }]"
        >
          <div :style="offsetStyle">
            <HeaderTitle :active="activeSection === formattedItems.length" />
            <Byline :isIntro="true" />
          </div>
        </div>
      </div>
    </Scroller>
    <div :class="{
      'dh-psy-intro__indicator-group': true,
      'dh-psy-intro__indicator-group--hidden': activeSection >= formattedItems.length || activeSection === -1
    }">

      <span
        v-for="(_, idx) in formattedItems"
        :key='idx'
        :class="{
        'dh-psy-intro__indicator': true,
        'dh-psy-intro__indicator--filled': idx <= activeSection,
        'dh-psy-intro__indicator--active': idx === activeSection
      }"
      />

    </div>
  </div>
</template>

<script>
import Scroller from '../Utilities/Scroller.vue'
import Paragraph from '../Typography/Paragraph.vue'
import HeaderTitle from '../Typography/Title.vue'
import Byline from '../Body/Byline.vue'
import ScrollVoiceText from '../Media/Audio/ScrollVoiceText.vue'
import Memorial from '../Sections/Memorial/index.vue'
import Illustration from '../Media/Graphs/illustration.vue'
import Logo from '../Widgets/Logo.vue'
import globalEventStore from '../../lib/global-event-store'

export default {
  components: {
    Memorial,
    Scroller,
    Paragraph,
    HeaderTitle,
    Byline,
    Logo,
    ScrollVoiceText,
    Illustration
  },
  props: {
    offsetStyle: {
      type: Object,
      required: false,
      default: () => ({})
    },
    isIntro: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default() {
        return this.$root.$data.props.doc.intro || []
      }
    }
  },
  data() {
    return {
      // items: this.$root.$data.props.doc.intro || [],
      activeSection: -1
    }
  },
  computed: {
    formattedItems() {
      const isLarge = (type, idx) => {
        // if (idx === this.items.length - 1) return true
        if (['sound'].includes(type)) return true

        return false
      }

      return this.items.map((item, idx) => {
        return {
          ...item,
          modifiers: isLarge(item.type, idx) ? 'section--large' : ''
        }
      })
    },
    rootMargin() {
      if (typeof window === 'undefined') return '-30% 0px -45%'
      if (window.innerHeight > window.innerWidth) {
        return '-30% 0px -45%'
      }
      return '-30% 0px -45%'
    },
    isVisible() {
      return this.activeSection !== -1 && this.activeSection !== this.formattedItems.length - 1
    }
  },
  methods: {
    handleActiveChange(e) {
      this.activeSection = e
      globalEventStore.dispatch(this.$root.$data.id, 'sendGaEvent', {
        action: `INTRO_CHANGE/${e}`
      })
    }
  }
}
</script>

<style scoped lang="postcss">
  .root {
    position: relative;
    z-index: 1;
    margin-bottom: 0;
    pointer-events: none;

    &:before {
      content: '';
      position: absolute;
      top: -100vh;
      top: calc(-100 * var(--dh-vh));
      left: 0;
      right: 0;
      bottom: -100vh;
      bottom: calc(-100 * var(--dh-vh));
      /* background: #141617; */
      pointer-events: none;
      opacity: 0;
      transition: 0.75s all ease-in-out;
    }

    &.root--active {
      &:before {
        opacity: 1;
      }
    }
  }

  div {
    position: relative;
  }

  .no-js .section {
    opacity: 1;
  }

  .paragraph {
    padding-top: 150px;
  }

  :global(.dh-psy-lead) {
    font-family: NRK Etica Slab;
    text-align: center;
    width: 75%;
    margin: 0 auto;
    text-shadow: 0 1px 20px rgba(30, 40, 45, 0.6), 0 2px 10px rgba(30, 40, 45, 0.8);
    line-height: 1.45;
    font-size: 1.2em;

    @media (min-width: 800px) {
      font-size: 1.5em;
    }
  }

  .section {
    min-height: 50vh;
    min-height: calc(50 * var(--dh-vh));
    opacity: 0.1;
    transition: 1s all ease-in-out;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-left: auto;
    margin-right: auto;
    pointer-events: none;
    &:first-of-type {
      padding-top: 20vh;
      padding-top: calc(20 * var(--dh-vh));

      @media (min-width: 800px) {
        padding-top: 25vh;
        padding-top: calc(25 * var(--dh-vh));
      }
    }

    &:last-of-type {
      padding-bottom: 5vh;
      padding-bottom: calc(5 * var(--dh-vh));

      @media (min-width: 900px) {
      }
    }

    & p {
      pointer-events: auto;
    }

    &.section--large {
      min-height: 60vh;
      padding-bottom: 40vh;
      padding-top: 40vh;
      min-height: calc(60 * var(--dh-vh));
      padding-bottom: calc(40 * var(--dh-vh));
      padding-top: calc(40 * var(--dh-vh));
    }

    &:first-of-type {
      /* padding-top: 0; */
    }
  }

  .section--active {
    opacity: 1;
    pointer-events: auto;
  }

  .dh-psy-intro__indicator-group {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 15px;
    width: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 1;
    pointer-events: 0;
    transition: 0.5s opacity ease-in-out;

    &.dh-psy-intro__indicator-group--hidden {
      opacity: 0;
    }
  }

  .dh-psy-intro__indicator {
    display: block;
    width: 4px;
    height: 4px;
    background: #fff;
    opacity: 0.2;
    margin: 3px;
    border-radius: 99px;
    transition: 0.5s opacity ease-in-out, 0.2s transform ease-in-out;
  }

  :global(.dh-psy-header-wrapper--white) {
    & .dh-psy-intro__indicator {
      background: #393939;
    }
  }

  .dh-psy-intro__indicator--filled {
    opacity: 0.6;
  }

  .dh-psy-intro__indicator--active {
    transform: scale(1.1);
  }

  :global(.section):first-of-type .dh-psy-img-lead {
    padding: 0 0 150px;

    @media (min-width: 800px) {
      padding: 50px 0;
    }
  }

  .dh-psy-img-lead {
    padding: 50px 0;
    & :global(.dh-psy-lead) {
      @media (min-width: 500px) {
        font-size: 1.1em;
      }

      @media (min-width: 900px) {
        font-size: 1.45em;
        width: 100%;
        max-width: 750px;
      }

      @media (min-width: 1200px) {
        font-size: 1.4em;
        width: 100%;
        max-width: 800px;
      }
    }
  }

  .dh-psy-img-lead__illustration {
    max-width: 400px;
    width: 90%;
    margin: 20px auto 0;

    @media (min-width: 900px) {
      margin: 50px auto;
    }
  }
</style>
